<div class="meter-container">
  <div class="single-meter-box single-meter-box-white" *ngFor="let value of leftValue">{{ value }}</div>
  <div class="comma-mark">,</div>
  <div class="single-meter-box single-meter-box-gray" *ngFor="let value of rightValue">{{ value }}</div>
  <div class="single-meter-box margin-left-10">{{ unit }}</div>
</div>
